import { Wrapper } from './ModelViewer.style';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'model-viewer': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

export type ModelViewerProps = {
  glb: string;
};

export function ModelViewer(props: ModelViewerProps) {
  const { glb } = props;

  return (
    <Wrapper className='ModelViewer-wrapper' data-testid='ModelViewer-wrapper'>
      <model-viewer
        // @ts-ignore
        alt=''
        src={glb}
        ar
        shadow-intensity='1'
        auto-rotate
        auto-rotate-delay='50'
        camera-controls
        disable-zoom
        touch-action='pan-y'
        class='custom-model-viewer'
        style={{ width: '100%', height: '100%' }}
      ></model-viewer>
    </Wrapper>
  );
}

export default ModelViewer;
